import React from "react";
import { DocumentCard,
    DocumentCardDetails,
    DocumentCardTitle,
    DocumentCardActivity,
    DocumentCardLocation,
    Icon} from '@fluentui/react';
import {ApproverDialog} from "./ApproverDialog";
import OwnerChange from "./ChangeValues/OwnerChange";
import { ChangeTaskType } from '../../GlobalConst/globalEnums';
import { renderDateTime, renderQuota, renderQuotaUsage } from "../../helpers/HelperMethods";
import Api from '../../services/Api'

class ApproveChangeTask extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showApproveDialog: false
        }
    }

    _mapOwnerForPeople(user) {
        return user ? [{ name: user.displayName }] : [];
    }

    _onLocationClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        window.open(e.target.href, '_blank');
    }

    getTitle = (taskType) => {
        switch (taskType) {
            case ChangeTaskType.owner:
            case ChangeTaskType.emptyOwner:
                return 'Administrator change'
            case ChangeTaskType.quotaLineManagerApproval:
            case ChangeTaskType.quotaAppManagerApproval:
                return 'Quota change'
            case ChangeTaskType.limitVersioning:
                return this.props.change.site.title
            case ChangeTaskType.extendMs365Archive:
                return 'Extend MS 365 Archive'
            case ChangeTaskType.restoreMs365Archived:
                return 'Restore MS 365 Archived Site'
            default:
                return null
        }
    }

    getChangeDetails = (change) => {
        switch (change.type) {
            case ChangeTaskType.owner:
            case ChangeTaskType.emptyOwner:
                return <OwnerChange owner = {change.site.owner} newOwner={change.changeDbObject}/>
            case ChangeTaskType.quotaLineManagerApproval:
            case ChangeTaskType.quotaAppManagerApproval:
                return (
                    <div style={quotaApprovalStyles}>
                        <div>Quota: {renderQuota(change.currentValue)} <Icon iconName="Forward" style={{ padding: '5px', verticalAlign: 'middle', lineHeight: '14px' }}/> {renderQuota(change.changeValue)}</div>
                        <div>Quota usage: {renderQuotaUsage(change.site.quotaUsage, change.site.quotaValue, change.site.statistics ? change.site.statistics.storageUsedMB : null)} </div>
                        <div>Business justification: {change.additionalData}</div>
                    </div>
                )
            case ChangeTaskType.limitVersioning:
                return  <div style={quotaApprovalStyles}>
                            <p><b>Dear {this.props.change.approver.displayName}</b></p>
                            <p>You are administrator of <a href={this.props.change.site.url} target="_blank">{this.props.change.site.title}</a> which requires your decision on the number of versions to be kept in all document libraries on your site. Please click on the button bellow to select the versioning limit for your site.</p>
                        </div>
            case ChangeTaskType.extendMs365Archive:
                return  <div style={quotaApprovalStyles}>
                            <p><b>Dear {this.props.change.approver.displayName}</b></p>
                            <p>You are administrator of <a href={this.props.change.site.url} target="_blank">{this.props.change.site.title}</a>. This site is archived in Microsoft 365 Archive solution from {new Date(this.props.change.site.ms365ArchiveDate).toLocaleDateString()}. Please approve this request task to extend archiving of the Site for 1 year, or reject if you no longer need it. After rejection Site will be deleted in 1 month.</p>
                        </div>
            case ChangeTaskType.restoreMs365Archived:
                return  <div style={quotaApprovalStyles}>
                            <div>Business justification: {change.additionalData}</div>
                        </div>
            default:
                return null
        }
    }

    onReject = (comment) => {
        const url = '/RejectSiteChange'
        this.postDecision({comment}, url);
    }

    onApprove = (approveObject) => {
        const url = '/ApproveSiteChange';
        this.postDecision(approveObject, url);
    }

    postDecision(approveObject, urlPart)
    {
        const post = {
            id: this.props.change.id,
            ...approveObject
        };

        Api.post(urlPart, post)
            .then(res => res.data)
            .then(post => {
                    if (post === 200) {
                        this.props.refresh();
                    } else {

                        console.log("Update failed")
                    }
                }
            ).catch((error) => {
            console.log(error)})
    }

    render() {
        return (
            <div>
                <DocumentCard styles={cardStyles(this.props.change.type)} >
                    <DocumentCardDetails styles={detailsStyles} >
                        <div style={titleStyles}>
                            <DocumentCardTitle title={this.getTitle(this.props.change.type)} shouldTruncate={false} />
                        </div>
                        {
                            this.props.change.type !== ChangeTaskType.limitVersioning &&
                            <DocumentCardLocation 
                                styles={urlStyles} 
                                location={this.props.change.site.url} 
                                locationHref={this.props.change.site.url} 
                                onClick={this._onLocationClick} 
                            />
                        }
                        {
                            this.getChangeDetails(this.props.change)
                        }
                    </DocumentCardDetails>
                    { 
                        this.props.change.type === ChangeTaskType.emptyOwner
                        ?   <div style={createdByStyles}>Change initiated by automatic process due to current owner disabled account.</div>
                        :   (this.props.change.createdBy && 
                            <div style={createdByStyles}>
                                <div>Change requested by: </div>
                                <DocumentCardActivity
                                    activity={`Created on ${renderDateTime(this.props.change.requestDate)}`}
                                    people={this._mapOwnerForPeople(this.props.change.createdBy)}
                                />
                            </div>)

                    }
                    <div style={iconContainerStyles}> 
                            <ApproverDialog
                                buttonName={this.props.change.type === ChangeTaskType.limitVersioning ? "Set versioning limit" : "Decision"}
                                title={this.props.change.type === ChangeTaskType.limitVersioning ? "Approve or decline site change" : "Approve or reject site change"}
                                text={this.props.change.type === ChangeTaskType.extendMs365Archive ? "Approve for extend archiving time or reject for deletion" : null}
                                hideComment={this.props.change.type === ChangeTaskType.extendMs365Archive}
                                onReject={this.onReject}
                                onApprove={this.onApprove}
                                versions={this.props.change.type === ChangeTaskType.limitVersioning && this.props.change.changeValue}
                                versionsDays={this.props.change.type === ChangeTaskType.limitVersioning && this.props.change.additionalData}
                                rejectBtnText={this.props.change.type === ChangeTaskType.limitVersioning && 'Decline'}
                            />
                    </div>
                </DocumentCard>
            </div>
        );
    }
}
const urlStyles = {
    root: {
        color: 'rgb(0, 120, 212)',
        fontSize: '14px',
        // fontWeight: 'bold',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        paddingTop: 0,
        overflow: 'auto'
    }
}

const createdByStyles = {
    padding: '8px',
    fontSize: '12px',
    flex: 1
}

const iconContainerStyles = {
    display: 'flex',
    flexDirection: 'column'
}
const titleStyles = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxHeight: '35px'
}

const cardStyles = (type) => ({
    root: {
        marginRight: 20,
        marginBottom: 20,
        width: 400,
        height: 300,
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid',
        borderColor: type === ChangeTaskType.quotaAppManagerApproval ? 'rgb(255, 0, 15)' : 'grey'
    }
})

const detailsStyles = {
    root: {
        height: 235,
        flex: 5,
        justifyContent: 'start'
    }
}

const quotaApprovalStyles = {
    padding: '0 12px', 
    fontSize: '14px', 
    overflow: 'auto',
    lineHeight: '20px'
}

export default ApproveChangeTask


// WEBPACK FOOTER //
// ./src/components/ManageCenter/ApproveChangeTask.js